import 'nodelist-foreach-polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/routes';
import store from '@/store';

Vue.use(Router);

let router = new Router({
    // 'mode': 'history',
    'base': process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { 'x': 0, 'y': 0 };
    }
});

router.beforeEach((to, from, next) => {
    // if (store.state.user.isProfileCompleted === 0) {
    if (store.state.user.isProfileCompleted === 0 && store.state.user.userRole !== 4) {
        if (
            to.name !== 'login' &&
            to.name !== 'register' &&
            to.name !== 'forgot-password' &&
            to.name !== 'doctor-profile' &&
            to.name !== 'pharmacy-user-profile' &&
            to.name !== 'user-profile'
        ) {
            // console.log(to);
            // if (store.state.user.userRole === 1 || store.state.user.userRole === 4) {
            if (store.state.user.userRole === 1) {
                next({
                    'name': 'user-profile'
                });
            } else if (store.state.user.userRole === 2) {
                next({
                    'name': 'doctor-profile'
                });
            } else if (store.state.user.userRole === 3) {
                next({
                    'name': 'pharmacy-user-profile'
                });
            }
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
